module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#filter",
      toString: function () {
        return this.url;
      }
    }